"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2067],{

/***/ 52067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _codebuild_output_src3438950203_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16835);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14416);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18132);
/* harmony import */ var react_cookie__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70461);
/* harmony import */ var src_redux_nlt_offer_actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57543);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51469);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);









var StickyBar = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return __webpack_require__.e(/* import() */ 3073).then(__webpack_require__.bind(__webpack_require__, 43073));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(43073)];
    }
  }
});

var StickyBarContainer = function StickyBarContainer(_ref) {
  var offerData = _ref.offerData,
      visible = _ref.visible;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$)(),
      t = _useTranslation.t;

  var isMobile = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .useBreakpointValue */ .Sx)({
    base: true,
    md: false
  });
  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();

  var _useCookies = (0,react_cookie__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(),
      _useCookies2 = (0,_codebuild_output_src3438950203_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_useCookies, 3),
      setCookie = _useCookies2[1],
      removeCookie = _useCookies2[2];

  var userProfile = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function (state) {
    var _state$user;

    return (_state$user = state.user) === null || _state$user === void 0 ? void 0 : _state$user.profile;
  });
  var priceVatIncluded = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function (state) {
    return state.nlt.priceVatIncluded;
  });

  var openCustomizeModal = function openCustomizeModal(step) {
    if (step > 0) {
      setCookie('hideStep0', '1', {
        path: '/'
      });
    } else {
      removeCookie('hideStep0', {
        path: '/'
      });
    }

    dispatch((0,src_redux_nlt_offer_actions__WEBPACK_IMPORTED_MODULE_3__/* .toggleCustomizeModal */ .K2)({
      step: step
    }));
  };

  var modalStepToPreconfigured = 1;
  var modalStepToCustom = 0;

  if (userProfile && userProfile.id) {
    // utente riconosciuto, deve solo ri-confermare i propri dati
    modalStepToPreconfigured = 2;
    modalStepToCustom = 2;
  } else if (userProfile && userProfile.deal) {
    // configurazione offerta preesistente, vai al chatbot
    modalStepToPreconfigured = 3;
    modalStepToCustom = 3;
  }

  var primaryButton = {
    title: t('offerContainer:primaryTitle', {
      value: "".concat(offerData.vehicle.brand, " ").concat(offerData.vehicle.model)
    }),
    action: isMobile ? t('offerContainer:primaryActionStickyMobile') : t('offerContainer:primaryActionSticky'),
    onClick: function onClick() {
      return openCustomizeModal(modalStepToPreconfigured);
    }
  };
  var secondaryButton = {
    title: t('offerContainer:secondaryTitle', {
      value: "".concat(offerData.vehicle.brand, " ").concat(offerData.vehicle.model)
    }),
    action: t('offerContainer:secondaryActionSticky'),
    onClick: function onClick() {
      return openCustomizeModal(modalStepToCustom);
    }
  };
  var expirationValue = offerData.expirationDate ? t('nltOffersComponent:badge', {
    value: Math.floor((new Date().getTime() - Date.parse(offerData.expirationDate)) / (24 * 60 * 60 * 1000))
  }) : null;
  var priceValue = priceVatIncluded ? Math.round(offerData.monthlyRate * 1.22) : offerData.monthlyRate;
  var priceDescription = priceVatIncluded ? t('offerContainer:priceDescriptionVatIncluded') : t('offerContainer:priceDescription');
  var depositValue = offerData.deposit ? priceVatIncluded ? Math.round(offerData.deposit * 1.22) : offerData.deposit : 0;
  var depositDescription = priceVatIncluded ? t('offerContainer:depositDescriptionVatIncluded') : t('offerContainer:depositDescription');
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StickyBar, {
    sectionTitle: "".concat(offerData.vehicle.brand, " ").concat(offerData.vehicle.model),
    subtitle: offerData.vehicle.version,
    priceValue: t('offerContainer:priceValue', {
      value: priceValue.toLocaleString('it-IT')
    }),
    priceDescription: priceDescription,
    durationTitle: t('offerContainer:durationTitle'),
    durationValue: t('offerContainer:durationValue', {
      value: offerData.contractLength.toLocaleString('it-IT')
    }),
    distanceTitle: t('offerContainer:distanceTitleShort'),
    distanceValue: t('offerContainer:distanceValue', {
      value: offerData.annualMileage == 0 ? 'illimitati' : offerData.annualMileage.toLocaleString('it-IT')
    }),
    depositTitle: t('offerContainer:depositTitle'),
    depositValue: depositValue ? t('offerContainer:depositValue', {
      value: depositValue.toLocaleString('it-IT')
    }) : t('offerContainer:depositValueZero'),
    depositDescription: depositValue ? depositDescription : '',
    expirationValue: expirationValue,
    visible: visible,
    active: offerData.status,
    primary: primaryButton,
    hasSecondaryAction: offerData.variations.length > 0,
    secondary: secondaryButton
  });
};

/* harmony default export */ __webpack_exports__["default"] = (StickyBarContainer);

/***/ }),

/***/ 70461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useCookies; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/cookie/index.js
var cookie = __webpack_require__(76489);
;// CONCATENATED MODULE: ./node_modules/universal-cookie/es6/utils.js

function hasDocumentCookie() {
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function cleanCookies() {
    document.cookie.split(';').forEach(function (c) {
        document.cookie = c
            .replace(/^ +/, '')
            .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
}
function parseCookies(cookies, options) {
    if (typeof cookies === 'string') {
        return cookie.parse(cookies, options);
    }
    else if (typeof cookies === 'object' && cookies !== null) {
        return cookies;
    }
    else {
        return {};
    }
}
function isParsingCookie(value, doNotParse) {
    if (typeof doNotParse === 'undefined') {
        // We guess if the cookie start with { or [, it has been serialized
        doNotParse =
            !value || (value[0] !== '{' && value[0] !== '[' && value[0] !== '"');
    }
    return !doNotParse;
}
function readCookie(value, options) {
    if (options === void 0) { options = {}; }
    var cleanValue = cleanupCookieValue(value);
    if (isParsingCookie(cleanValue, options.doNotParse)) {
        try {
            return JSON.parse(cleanValue);
        }
        catch (e) {
            // At least we tried
        }
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') {
        return value.substr(2);
    }
    return value;
}

;// CONCATENATED MODULE: ./node_modules/universal-cookie/es6/Cookies.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var Cookies = /** @class */ (function () {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = parseCookies(cookies, options);
        new Promise(function () {
            _this.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
        }).catch(function () { });
    }
    Cookies.prototype._updateBrowserValues = function (parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) {
            return;
        }
        this.cookies = cookie.parse(document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function (params) {
        for (var i = 0; i < this.changeListeners.length; ++i) {
            this.changeListeners[i](params);
        }
    };
    Cookies.prototype.get = function (name, options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        return readCookie(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function (options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        var result = {};
        for (var name_1 in this.cookies) {
            result[name_1] = readCookie(this.cookies[name_1], options);
        }
        return result;
    };
    Cookies.prototype.set = function (name, value, options) {
        var _a;
        if (typeof value === 'object') {
            value = JSON.stringify(value);
        }
        this.cookies = __assign(__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = cookie.serialize(name, value, options);
        }
        this._emitChange({ name: name, value: value, options: options });
    };
    Cookies.prototype.remove = function (name, options) {
        var finalOptions = (options = __assign(__assign({}, options), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 }));
        this.cookies = __assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = cookie.serialize(name, '', finalOptions);
        }
        this._emitChange({ name: name, value: undefined, options: options });
    };
    Cookies.prototype.addChangeListener = function (callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function (callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) {
            this.changeListeners.splice(idx, 1);
        }
    };
    return Cookies;
}());
/* harmony default export */ var es6_Cookies = (Cookies);

;// CONCATENATED MODULE: ./node_modules/universal-cookie/es6/index.js

/* harmony default export */ var es6 = (es6_Cookies);

;// CONCATENATED MODULE: ./node_modules/react-cookie/es6/Cookies.js

/* harmony default export */ var react_cookie_es6_Cookies = (es6);

;// CONCATENATED MODULE: ./node_modules/react-cookie/es6/CookiesContext.js


var CookiesContext = react.createContext(new react_cookie_es6_Cookies());
var Provider = CookiesContext.Provider, Consumer = CookiesContext.Consumer;
/* harmony default export */ var es6_CookiesContext = (CookiesContext);

;// CONCATENATED MODULE: ./node_modules/react-cookie/es6/utils.js
function isInBrowser() {
    return (typeof window !== 'undefined' &&
        typeof window.document !== 'undefined' &&
        typeof window.document.createElement !== 'undefined');
}

;// CONCATENATED MODULE: ./node_modules/react-cookie/es6/useCookies.js



function useCookies(dependencies) {
    var cookies = (0,react.useContext)(es6_CookiesContext);
    if (!cookies) {
        throw new Error('Missing <CookiesProvider>');
    }
    var initialCookies = cookies.getAll();
    var _a = (0,react.useState)(initialCookies), allCookies = _a[0], setCookies = _a[1];
    var previousCookiesRef = (0,react.useRef)(allCookies);
    if (isInBrowser()) {
        (0,react.useLayoutEffect)(function () {
            function onChange() {
                var newCookies = cookies.getAll();
                if (shouldUpdate(dependencies || null, newCookies, previousCookiesRef.current)) {
                    setCookies(newCookies);
                }
                previousCookiesRef.current = newCookies;
            }
            cookies.addChangeListener(onChange);
            return function () {
                cookies.removeChangeListener(onChange);
            };
        }, [cookies]);
    }
    var setCookie = (0,react.useMemo)(function () { return cookies.set.bind(cookies); }, [cookies]);
    var removeCookie = (0,react.useMemo)(function () { return cookies.remove.bind(cookies); }, [cookies]);
    return [allCookies, setCookie, removeCookie];
}
function shouldUpdate(dependencies, newCookies, oldCookies) {
    if (!dependencies) {
        return true;
    }
    for (var _i = 0, dependencies_1 = dependencies; _i < dependencies_1.length; _i++) {
        var dependency = dependencies_1[_i];
        if (newCookies[dependency] !== oldCookies[dependency]) {
            return true;
        }
    }
    return false;
}


/***/ })

}]);